import { getDistance } from '@/utils/getDistance';

export const getClosestSweepFromObject = ({ allSweeps, target }) => {
  const targetPosition = { x: target.positionX, y: target.positionY, z: target.positionZ };
  let closestSweep;
  let closestDistance = Infinity;
  allSweeps.forEach((sweep) => {
    // We check if sweep floor undefined or target and sweep floor are the same
    if (sweep.floor === undefined || target.floor === undefined || sweep.floor === target.floor) {
      const sweepPosition = { x: sweep.positionX, y: sweep.positionY, z: sweep.positionZ };
      const distance = getDistance(sweepPosition, targetPosition);
      if ((closestDistance === null || distance < closestDistance) && sweep?.neighbourSweeps?.length > 0) {
        closestSweep = sweep;
        closestDistance = distance;
      }
    }
  });
  return { closestSweep, closestDistance };
};
